import * as THREE from "three"
import Experience from "./Experience"
import Animation from "./Animation.js"


export default class Raycasting {

    constructor(objects, hitTargets = objects) {
        this.experience = new Experience()
        this.mouse = new THREE.Vector2()
        this.raycaster = new THREE.Raycaster()
        this.sizes = this.experience.sizes
        this.camera = this.experience.camera
        this.scene = this.experience.scene
        this.animation = new Animation()
        this.canZoom = true
        this.objects = objects
        this.hitTargets = hitTargets
        this.screenFrame = this.experience.iframe ?? null
        this.dpad = this.objects.find((object) => object.name === "dpad") ?? null
        this.buttonGeometry = new THREE.PlaneGeometry(0.07, 0.07)
        this.buttonMaterial = new THREE.MeshBasicMaterial({
            transparent: true,
            opacity: 0,
            depthWrite: false,
            side: THREE.DoubleSide
        })

        this.setup()
    }

    setup() {
        this.mousemove()
        this.press()
        this.dpadButtons()
    }


    mousemove() {
        window.addEventListener("mousemove", (event) => {
            this.updatePointerPosition(event)
        })
    }

    press() {
        window.addEventListener("pointerdown", (event) => {
            if (event.pointerType === "mouse" && event.button !== 0) {
                return
            }

            const wasZoomedIn = this.camera.isZoomedIn
            this.updatePointerPosition(event)
            const consoleIntersect = this.raycasterSetup(this.hitTargets)
            
            if(!this.canZoom)
                return

            if (consoleIntersect) {
                this.camera.zoomToConsole()
            }
            else {
                this.camera.resetZoom()
            }

            if (!wasZoomedIn || !this.camera.isZoomedIn) {
                return
            }

            const intersect = this.raycasterSetup(this.objects)

            if (intersect) {
                const objectName = intersect.object.name

                if (objectName.startsWith("dpad-")) {
                    const direction = objectName.replace("dpad-", "")
                    this.animation.pressDpad(this.dpad, direction)

                    if (direction === "up") {
                        this.sendKeyboardInput("KeyW")
                    }

                    if (direction === "down") {
                        this.sendKeyboardInput("KeyS")
                    }

                    return
                }

                if (objectName === "a" || objectName === "a-button") {
                    this.sendKeyboardInput("Space")
                }

                if (objectName === "b" || objectName === "b-button") {
                    this.sendKeyboardInput("Escape")
                }

                const buttonKey = objectName.replace("-button", "")
                const consoleInstance = this.experience.world?.console
                const textMesh = consoleInstance?.buttonTexts?.[buttonKey]
                // console.log("Raycasting press - objectName:", objectName, "buttonKey:", buttonKey, "textMesh found:", textMesh)

                this.animation.pressButton(intersect.object, textMesh)
            }
        })
    }

    updatePointerPosition(event) {
        this.mouse.x = ((event.clientX / this.experience.sizes.width) - 0.5) * 2.0
        this.mouse.y = -((event.clientY / this.experience.sizes.height) - 0.5) * 2.0
    }

    sendKeyboardInput(code) {
        if (!this.camera.isZoomedIn) {
            return
        }

        const targetWindow = this.screenFrame?.contentWindow

        if (!targetWindow) {
            return
        }

        targetWindow.dispatchEvent(new KeyboardEvent("keydown", {
            code,
            bubbles: true
        }))
    }

    raycasterSetup(targetObjects = this.objects) {
        this.raycaster.setFromCamera(this.mouse, this.camera.instance)

        const intersects = this.raycaster.intersectObjects(targetObjects)

        const validIntersect = intersects.find((intersect) => intersect.object.name !== "dpad")

        return validIntersect ?? null

    }


    dpadButtons() {

        this.dpadUp = new THREE.Mesh(
            this.buttonGeometry,
            this.buttonMaterial
        )
        this.dpadDown = new THREE.Mesh(
            this.buttonGeometry,
            this.buttonMaterial
        )
        this.dpadLeft = new THREE.Mesh(
            this.buttonGeometry,
            this.buttonMaterial
        )
        this.dpadRight = new THREE.Mesh(
            this.buttonGeometry,
            this.buttonMaterial
        )
        this.dpadUp.position.set(-0.2, 0.2, 0.18)
        this.dpadDown.position.set(-0.2, 0.05, 0.18)
        this.dpadLeft.position.set(-0.27, 0.125, 0.18)
        this.dpadRight.position.set(-0.13, 0.125, 0.18)
        this.dpadUp.name = "dpad-up"
        this.dpadDown.name = "dpad-down"
        this.dpadLeft.name = "dpad-left"
        this.dpadRight.name = "dpad-right"



        this.scene.add(this.dpadUp, this.dpadDown, this.dpadLeft, this.dpadRight)
        this.objects.push(this.dpadUp, this.dpadDown, this.dpadLeft, this.dpadRight)
    }
    selectStartButtons() {



    }

    update() {
    }

}
